var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.75C9.96719 9.75 11.1562 8.575 11.1562 7.125V3.625C11.1562 2.175 9.96719 1 8.5 1C7.03281 1 5.84375 2.175 5.84375 3.625V7.125C5.84375 8.575 7.03281 9.75 8.5 9.75ZM13.6562 7.09375C13.6562 7.025 13.6 6.96875 13.5312 6.96875H12.5938C12.525 6.96875 12.4688 7.025 12.4688 7.09375C12.4688 9.28594 10.6922 11.0625 8.5 11.0625C6.30781 11.0625 4.53125 9.28594 4.53125 7.09375C4.53125 7.025 4.475 6.96875 4.40625 6.96875H3.46875C3.4 6.96875 3.34375 7.025 3.34375 7.09375C3.34375 9.72969 5.32188 11.9047 7.875 12.2125V13.8125H5.60469C5.39063 13.8125 5.21875 14.0359 5.21875 14.3125V14.875C5.21875 14.9438 5.2625 15 5.31563 15H11.6844C11.7375 15 11.7812 14.9438 11.7812 14.875V14.3125C11.7812 14.0359 11.6094 13.8125 11.3953 13.8125H9.0625V12.2203C11.6453 11.9391 13.6562 9.75156 13.6562 7.09375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFilled);
export default __webpack_public_path__ + "static/media/audio-filled.5eee346c7c521d5a373c42fbf851c4d0.svg";
export { ForwardRef as ReactComponent };